import Api, {ApiCall, ApiRequest} from "@/lib/Api";
import {setToken} from "@/lib/Storage";

export default {
    state : {
        user : null,
        token: null,
        loginError: null,
        plans: null,
        isLoading: false,
        currentPlan: null,
        error: '',
        success : '',
    },
    getters : {
        isLoggedIn : (state) => !!state.user,
        loginError : state => state.loginError,
        appError : state => state.error,
        currentUser : state => state.user,
        currentPlan : state => state.currentPlan,
        // currentPlan : state => {
        //     return state.plans && state.user ?
        //         state.plans.find(it => it.id === state.user.plan_id) : null
        // },
        isLoading : state => state.isLoading,
        success : state => state.success
    },
    actions : {

        async login({commit, dispatch}, [username, password]) {
            await commit('resetLoginErrors')
            const res = await ApiRequest(ApiCall(Api.Login, {username, password}));
            if (res.token) {
                setToken(res.token);
                await commit('loginSuccess', {user: res.user, token: res.token, plan_id: res.user.plan_id })
                const isEditor = res.user.permissions.find(it => it.indexOf('EDITOR') > -1)
                if (isEditor) await dispatch('getPlans');
            }
            else await commit('loginError', res.error)
            return true
        },

        async logout({commit}) {
            await ApiRequest(ApiCall(Api.Logout));
            return await commit('logout');
        },

        async getPlans({commit}) {
            const plans = await ApiRequest(ApiCall(Api.ListPlans));
            return await commit('onPlans', plans)
        },

        async checkLogin({commit, dispatch}) {
            const res = await ApiRequest(ApiCall(Api.CheckLogin));
            if (res.user) {
                await commit('loginSuccess', {user: res.user, token: null, plan_id: res.user.plan_id })
                const isAdmin = res.user.permissions.find(it => it.indexOf('ADMIN') > -1)
                if (isAdmin) await dispatch('getPlans');
            }
            return true
        },

        async setCurrentPlan({commit, dispatch}, plan_id) {
            const res = await ApiRequest(ApiCall(Api.SetCurrentPlan, plan_id));
            if (res.result === "ok") {
                await commit('setPlanRecipes',[])
                await commit('setPlanIcons',[])
                await dispatch('getMyPlan')
                await commit('setPlan', plan_id);
            }
            return true
        },

        async setLoading({commit}, isLoading) {
            if (isLoading) await commit('loading')
            else await commit('loaded')
            return true
        },

        async setSuccess({commit}, success) {
            await commit('success', success)
            if (success) {
                setTimeout(async () => await commit('clearSuccess'), 3000)
            }
            return true
        },
        async setError({commit}, error) {
            await commit('setError', error)
            if (error) {
                setTimeout(async () => await commit('clearError'), 5000)
            }
            return true
        }

    },
    mutations : {
        setPlan : (state, plan_id) =>  state.currentPlan = plan_id*1>0 ? plan_id : null ,
        resetLoginErrors: (state) => { state.loginError = null },
        loginSuccess: (state, {user, token, plan_id}) => {
            if (token) state.token = token
            state.user = user
            state.currentPlan = plan_id ? plan_id : null
        },
        loginError: (state, loginError) => {
            state.loginError = loginError;
            state.user = state.token = null;
        },
        setError: (state, error) => {
            console.log({error})
            state.error = error;
        },
        clearError: state => state.error = '',
        onPlans : (state, plans) => { state.plans = plans },
        logout : (state) => { state.user = state.token = state.plans = state.currentPlan = null; },
        loading: (state) => { state.isLoading = true; },
        loaded: (state) => { state.isLoading = false; },
        success: (state, success) => { state.success = success; },
        clearSuccess : state => state.success = '',
    }
}
